var map = {
	"./1. HABILITACIONES/data.json": 4111,
	"./2. RECINTOS EDUCACIONALES/data.json": 3970,
	"./3. REMODELACIONES/data.json": 1520,
	"./4. MONTAJE Y TECHUMBRE/data.json": 7773,
	"./5. MANTENCIONES MALL/data.json": 2088,
	"./6. Diseño de proyectos/data.json": 8271
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5254;